export const OPEN_ACCOUNT_WIDGET = 'OPEN_ACCOUNT_WIDGET';
export const CLOSE_ACCOUNT_WIDGET = 'CLOSE_ACCOUNT_WIDGET';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_THEME = 'SET_THEME';

export function openAccountWidget() {
  return {
    type: OPEN_ACCOUNT_WIDGET,
  };
}

export function closeAccountWidget() {
  return {
    type: CLOSE_ACCOUNT_WIDGET,
  };
}

export function setIsMobile(isMobile) {
  return {
    type: SET_IS_MOBILE,
    isMobile,
  };
}

export function setThemeId(themeId) {
  return {
    type: SET_THEME,
    themeId,
  };
}
